"use strict";
// THIS FILE IS AUTO-GENERATED BY THE ANALYTICS CODEGEN SCRIPT
// DO NOT MANUALLY MODIFY THIS FILE
// FOR MORE INFORMATION CHECK OUT: https://github.com/flexapp/genoa/pull/5762
exports.__esModule = true;
exports.UnderwritingRequestedAnalyticsEvent = exports.SignupCompletedAnalyticsEvent = exports.PhoneVerifiedAnalyticsEvent = exports.PaymentConnectedAnalyticsEvent = exports.CustomerAccountCreatedAnalyticsEvent = exports.CustomerAcceptedLoanAnalyticsEvent = exports.BillConnectedAnalyticsEvent = void 0;
var util_1 = require("./util");
/**
 * Triggers when the customer has successfully verified their phone number after having entered the one-time password (OTP) sent from our underlying Authentication Provider
 */
var PhoneVerifiedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('phone_verified');
exports.PhoneVerifiedAnalyticsEvent = PhoneVerifiedAnalyticsEvent;
/**
 * Triggers when the customer has successfully created their account after having entered their legal First Name, legal Last Name and email address on the Create Account screen in onboarding
 */
var CustomerAccountCreatedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('customer_account_created');
exports.CustomerAccountCreatedAnalyticsEvent = CustomerAccountCreatedAnalyticsEvent;
/**
 * Triggers when the customer has successfully created a Biller Connection and matched with it to their account
 */
var BillConnectedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('bill_connected');
exports.BillConnectedAnalyticsEvent = BillConnectedAnalyticsEvent;
/**
 * Triggers when the customer requests for a Soft Credit Check against their account
 */
var UnderwritingRequestedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('underwriting_requested');
exports.UnderwritingRequestedAnalyticsEvent = UnderwritingRequestedAnalyticsEvent;
/**
 * Trigger when the customer accepts the initial terms of the loan offer presented to them
 */
var CustomerAcceptedLoanAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('customer_accepted_loan');
exports.CustomerAcceptedLoanAnalyticsEvent = CustomerAcceptedLoanAnalyticsEvent;
/**
 * Triggers when the customer has successfully connected a Payment Method to their account
 */
var PaymentConnectedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('payment_connected');
exports.PaymentConnectedAnalyticsEvent = PaymentConnectedAnalyticsEvent;
/**
 * Triggers when the customer lands on the Congrats screen after successfully completing the onboarding funnel
 */
var SignupCompletedAnalyticsEvent = (0, util_1.newAnalyticsEventWithPropertiesFactory)('signup_completed');
exports.SignupCompletedAnalyticsEvent = SignupCompletedAnalyticsEvent;
